const quickLinks = [
  { label: "最新可用地址", href: "#lines" },
  { label: "话题墙", href: "#topics" },
  { label: "今日瓜讯", href: "#news" },
  { label: "热瓜榜", href: "#rank" },
];

const entryLinks = [
  { label: "网页直连入口", href: "#entry" },
  { label: "App 下载安装", href: "#app" },
  { label: "备用线路合集", href: "#entry" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-black text-background-50">51黑料网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              本站为入口导航页面，汇总 51黑料网 官网、最新可用网址、入口与 app 安装方式，
              帮助用户快速定位当前能用的访问渠道。本页不存储、不生产、不提供任何具体内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200">
                最后更新 10:24
              </span>
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200">
                线路检测 6 条
              </span>
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200">
                话题覆盖 1286
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="flex items-center gap-2 text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">入口与下载</h3>
            <ul className="mt-4 space-y-3">
              {entryLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="flex items-center gap-2 text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-50/10 pt-6">
          <p className="text-xs leading-relaxed text-background-400">
            免责声明：本页仅汇总公开的入口与地址信息用于导航，所有展现内容均为演示用途，
            页面不参与任何内容的存储与传播。请用户在遵守当地法律法规的前提下合理使用网络服务。
          </p>
          <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-background-400">
              © 2026 51黑料网导航页 · 51黑料网 官网 最新地址 网址 入口 app下载
            </p>
            <p className="flex items-center gap-2 text-xs text-background-400">
              <i className="ri-refresh-line"></i>
              地址实时更新 · 建议收藏本页
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}